export const FONT_SIZE_NORMAL = '1rem';
export const FONT_SIZE_LARGE = '1.125rem';
export const FONT_SIZE_XXL = '1.5rem';
export const FONT_SIZE_XXXL = '1.875rem';
export const FONT_SIZE_XXXXL = '2rem';
export const FONT_SIZE_ENORMOUS = '3rem';
export const HEADER_SIZE = '2.5rem';
export const SUB_HEADER_SIZE = '3.125rem';
export const PAGE_MARGIN = '2rem';
export const NAVIGATION_DRAWER_WIDTH = '14rem';
export const SIDEBAR_MIN_WIDTH = 50;
export const SIDEBAR_MAX_WIDTH = 400;
export const SIDEBAR_NARROW_BREAKPOINT = 150;
